export default "__VITE_ASSET___kTSYLoz__"